import Cookies from 'js-cookie'

export const getImageDimensions = (url) => {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.onload = () => {
        const dimensions = `${img.width}x${img.height}`;
        resolve(dimensions);
      };
      img.onerror = (error) => {
        reject(error);
      };
      img.src = url;
    });
};

export const formatFileSize = (bytes) => {
    if (bytes === 0) return '0 Bytes';
    const k = 1024;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
};

export const formattedDate = (date) => {
    var options = { year: 'numeric', month: 'short', day: 'numeric' };

    var newDate = new Date(date);
    var formatteddate = newDate.toLocaleDateString('en-US', options);
    return formatteddate;
}

export const formattedDateTime = (date) => {
  const newDate = new Date(date);

  const datePart = newDate.toLocaleDateString('en-US', {
    month: 'long',
    day: 'numeric',
    year: 'numeric',
  });

  const timePart = newDate.toLocaleTimeString('en-US', {
    hour: 'numeric',
    minute: '2-digit',
    hour12: true,
  });

  return `${datePart} at ${timePart.toLowerCase()}`;
};


export const hasPermission = (routeId) => {
  const cookieValue = Cookies.get('adminUserData');

  // Check if cookie exists and is not "undefined"
  if (!cookieValue || cookieValue === "undefined") {
    return true;
  }

  let adminUserData;
  try {
    adminUserData = JSON.parse(cookieValue);
  } catch (error) {
    console.error("Invalid adminUserData cookie:", error);
    return false;
  }

  const permissions = adminUserData?.permissions || [];

  const permission = permissions.find(p => p.routeId === routeId);

  // return true only if both read AND write are true
  return !!(permission && permission.read === true && permission.write === true);
};

export const exportToCSV = (data, fileName, columns = null) => {
  if (!data || data.length === 0) {
    console.warn('No data to export');
    return;
  }

  const formatValue = (value) => {
    if (value === null || value === undefined) return '';

    // Handle Array
    if (Array.isArray(value)) {
      return value
        .map((item) => {
          if (typeof item === 'object' && item !== null) {
            return Object.entries(item)
              .filter(
                ([, val]) =>
                  val !== null &&
                  val !== undefined &&
                  val !== ''
              )
              .map(([key, val]) => `${key}: ${val}`)
              .join(', ');
          }

          return item;
        })
        .join(', ');
    }

    // Handle Object
    if (typeof value === 'object') {
      const entries = Object.entries(value).filter(
        ([, val]) =>
          val !== null &&
          val !== undefined &&
          val !== ''
      );

      // If object is empty then return blank
      if (entries.length === 0) return '';

      return entries
        .map(([key, val]) => `${key}: ${val}`)
        .join(', ');
    }

    return value;
  };

  const escapeCSV = (value) => {
    const formattedValue = formatValue(value);

    const stringValue = String(formattedValue);

    // Escape quotes
    const escapedValue = stringValue.replace(/"/g, '""');

    // Wrap in quotes if contains comma/newline/quote
    if (
      escapedValue.includes(',') ||
      escapedValue.includes('\n') ||
      escapedValue.includes('"')
    ) {
      return `"${escapedValue}"`;
    }

    return escapedValue;
  };

  let headerRow = '';
  let dataRows = '';

  if (columns) {
    headerRow =
      columns.map((col) => escapeCSV(col.name)).join(',') + '\n';

    dataRows = data
      .map((row) => {
        return columns
          .map((col) => {
            const value =
              typeof col.selector === 'function'
                ? col.selector(row)
                : row[col.selector];

            return escapeCSV(value);
          })
          .join(',');
      })
      .join('\n');
  } else {
    const keys = Object.keys(data[0]);

    headerRow = keys.map((key) => escapeCSV(key)).join(',') + '\n';

    dataRows = data
      .map((row) => {
        return keys
          .map((key) => escapeCSV(row[key]))
          .join(',');
      })
      .join('\n');
  }

  const csvContent = '\uFEFF' + headerRow + dataRows;
  const blob = new Blob([csvContent], {
    type: 'text/csv;charset=utf-8;',
  });
  const link = document.createElement('a');
  const url = URL.createObjectURL(blob);
  link.setAttribute('href', url);
  link.setAttribute('download', `${fileName}.csv`);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
};